import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Renata M.',
    age: '47 anos',
    location: 'Campinas, SP',
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
    quote: 'Eu achava que estava engordando, mas era muito inchaço. Nos primeiros dias já senti a barriga menos estufada e minhas roupas ficaram mais confortáveis. O melhor foi voltar a me sentir leve sem passar fome.'
  }, {
    name: 'Patrícia A.',
    age: '52 anos',
    location: 'Belo Horizonte, MG',
    image: 'https://images.unsplash.com/photo-1531123897727-8f129e1bf98c?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
    quote: 'Depois dos 50, meu corpo parecia não responder a nada. Com esse protocolo, senti menos retenção, menos peso no fim do dia e mais controle na alimentação. Foi simples de seguir e muito realista.'
  }, {
    name: 'Silvana R.',
    age: '58 anos',
    location: 'Curitiba, PR',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
    quote: 'Meu rosto amanhecia inchado e a barriga estufava muito ao longo do dia. Em poucos dias já percebi diferença no espelho e principalmente na sensação de leveza. Parece que meu corpo destravou.'
  }, {
    name: 'Juliana F.',
    age: '44 anos',
    location: 'Salvador, BA',
    image: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80',
    quote: 'Gostei porque não é uma dieta impossível. São orientações simples que encaixaram na minha rotina. Me senti menos inchada, com mais disposição e mais feliz ao vestir minhas roupas.'
  }];
  return <section className="py-16 md:py-24 bg-brand-cream" data-id="element-243">
      <div className="max-w-6xl mx-auto px-5 md:px-8" data-id="element-244">
        <div className="text-center mb-12" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-4" data-id="element-246">
            O Que Outras Mulheres 40+ Estão Dizendo
          </h2>
          <h3 className="text-lg text-brand-text/80 max-w-2xl mx-auto" data-id="element-247">
            Relatos de mulheres que começaram a se sentir mais leves, menos
            estufadas e mais confortáveis nas próprias roupas.
          </h3>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-248">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-sage/20 flex flex-col" data-id="element-249">
              <div className="flex text-brand-gold mb-4" data-id="element-250">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-251" />)}
              </div>
              <p className="text-brand-text/80 text-sm italic leading-relaxed flex-grow mb-6" data-id="element-252">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center mt-auto pt-4 border-t border-brand-sage/20" data-id="element-253">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-3 border border-brand-sage/30" data-id="element-254" />
                <div data-id="element-255">
                  <p className="font-bold text-brand-dark text-sm" data-id="element-256">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-brand-text/60" data-id="element-257">
                    {testimonial.age} • {testimonial.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center space-y-4" data-id="element-258">
          <p className="text-xs text-brand-text/50" data-id="element-259">
            Resultados individuais podem variar.
          </p>
          <p className="text-lg font-medium text-brand-dark max-w-3xl mx-auto" data-id="element-260">
            Resultados individuais podem variar, mas a sensação de leveza e
            bem-estar começa quando você dá ao seu corpo a estratégia certa.
          </p>
        </div>
      </div>
    </section>;
}